
  export const safeParse = (string) =>{
    try {
      // console.log(JSON.parse(string))
      return JSON.parse(string)
    } catch (error) {
      return 'invalid'
    }
  }